<template>
  <div class="help-center__downloads">
    <h2 class="help-center__title">
      <img
        src="/static/images/icon-download-purple.svg"
        alt="icone-download"
      />
      <span>Downloads</span>
    </h2>
    <div class="help-center__dowloads-wrapper">
      <download-card
        v-for="card in cards"
        :key="card.id"
        :content="card"
        :show-version="true"
      />
    </div>
  </div>
</template>

<script>
import DownloadCard from '@/components/Download/DownloadCard';

export default {
  name: 'HelpCenterDownloads',
  components: {
    'download-card': DownloadCard,
  },
  data() {
    return {
      cards: [
        {
          id: 1,
          title: 'Windows',
          description: 'Novo sistema de impressão Álvaro de etiquetas para o sistema operacional Windows',
          image: '/static/images/icon-downloads.svg',
          versionText: '5',
          url: 'https://storageapoiob2bprd.blob.core.windows.net/printer-plugin/AOL2_0PlugindeImpressão.exe',
        },
        {
          id: 2,
          title: 'Instalador Zebra',
          description: 'Driver para impressoras Zebra dos modelos, GC 420T, TLP 2844, ZD 220,  Honeywell PC42t e Elgin L42PRO',
          image: '/static/images/icon-downloads.svg',
          versionText: '4.2',
          url: 'https://storageapoiob2bprd.blob.core.windows.net/printer-client-binaries-instalador-zebra/Instalador Zebra.zip',
        },
        {
          id: 3,
          title: 'Documento para interface XML',
          description: 'Documento para geração do XML de integração com o AOL 2.0 pelo sistema do laboratório',
          image: '/static/images/icon-downloads.svg',
          versionText: '4.1',
          url: 'https://storageapoiob2bprd.blob.core.windows.net/documentacao-interface-xml/Manual_Tecnico-Interface_XML_AOL2.0.zip',
        },
        {
          id: 4,
          title: 'Tabela de crítica',
          description: 'Documento contendo os exames, códigos e regras para a interface com o AOL 2.0',
          image: '/static/images/icon-downloads.svg',
          versionText: '4.1',
          url: 'https://storageapoiob2bprd.blob.core.windows.net/tabela-de-critica/Tabela_de_Critica.xlsx',
        },
        {
          id: 5,
          title: 'Arquivo de crítica no formato XML',
          description: 'Arquivo XML contendo os códigos de exame e suas regras para a interface com o AOL 2.0',
          image: '/static/images/icon-downloads.svg',
          versionText: '4.1',
          url: 'https://storageapoiob2bprd.blob.core.windows.net/arquivo-de-critica-no-formato-xml/Interface__Arquivo_de_Critica.zip',
        },
        {
          id: 6,
          title: 'Manual de Integração via Webservice',
          description: 'Documento contendo detalhes, instruções e exemplos do protocolo de integração via Etiqueta primária.',
          image: '/static/images/icon-downloads.svg',
          versionText: '9.1',
          url: 'https://storageapoiob2bprd.blob.core.windows.net/documentacao-aolws/WebService_AOLWS.zip',
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.help-center {
  font-family: 'Exo 2' !important;

  &__dowloads-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
